import { Spinner, SpinnerSize, Stack } from "@fluentui/react";
import React from "react";
import styles from "../../styles/loader.module.css";

const Loader = ({ loaderText }: { loaderText?: string }) => {
  return (
    <Stack className={styles.container}>
      <Spinner size={SpinnerSize.large} label={loaderText} className={styles.spinner} />
    </Stack>
  );
};

export default Loader;
